export default {
  bind(el) {
    let scrollTimer;

    // 开始滚动
    const startScroll = () => {
      scrollTimer = setInterval(() => {
        el.scrollTop += 1;
        // console.log(`scrollTop: ${el.scrollTop}, clientHeight: ${el.clientHeight}, scrollHeight: ${el.scrollHeight}`);
        if (el.scrollTop + el.clientHeight >= el.scrollHeight - 1) {
          el.scrollTop = 0;
        }
      }, 60);
    };

    // 停止滚动
    const stopScroll = () => {
      clearInterval(scrollTimer);
    };

    el.addEventListener('mouseenter', stopScroll);
    el.addEventListener('mouseleave', startScroll);

    // 初始化滚动
    startScroll();
  },
  unbind(el) {
    el.removeEventListener('mouseenter', stopScroll);
    el.removeEventListener('mouseleave', startScroll);
    clearInterval(scrollTimer);
  }
};